import api from "@/services/api";

const state = {
  lines: [],
  importHistory: [],
  candidates: [],
  summary: null,
};

const mutations = {
  SET_LINES(state, data) {
    state.lines = data;
  },
  SET_IMPORT_HISTORY(state, data) {
    state.importHistory = data;
  },
  SET_CANDIDATES(state, data) {
    state.candidates = data;
  },
  SET_SUMMARY(state, data) {
    state.summary = data;
  },
};

const actions = {
  async importStatement({ dispatch }, payload) {
    try {
      const result = await api.post("/bank-reconciliation/import", payload);
      await Promise.all([dispatch("getLines"), dispatch("getImportHistory")]);
      return result.data;
    } catch (error) {
      console.error("Error importing bank statement:", error.message);
      throw error;
    }
  },

  async getLines({ commit }, params = {}) {
    try {
      const res = await api.get("/bank-reconciliation/lines", { params });
      commit("SET_LINES", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching bank statement lines:", error.message);
      throw error;
    }
  },

  async getImportHistory({ commit }) {
    try {
      const res = await api.get("/bank-reconciliation/import-history");
      commit("SET_IMPORT_HISTORY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching bank import history:", error.message);
      throw error;
    }
  },

  async getCandidates({ commit }, lineId) {
    try {
      const res = await api.get(`/bank-reconciliation/lines/${lineId}/candidates`);
      commit("SET_CANDIDATES", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching match candidates:", error.message);
      throw error;
    }
  },

  async confirmMatch({ dispatch }, { lineId, transactionId }) {
    try {
      const result = await api.put(`/bank-reconciliation/lines/${lineId}/match`, { transactionId });
      await dispatch("getLines");
      return result.data;
    } catch (error) {
      console.error("Error confirming match:", error.message);
      throw error;
    }
  },

  async unmatch({ dispatch }, lineId) {
    try {
      await api.put(`/bank-reconciliation/lines/${lineId}/unmatch`);
      await dispatch("getLines");
    } catch (error) {
      console.error("Error unmatching line:", error.message);
      throw error;
    }
  },

  async ignoreLine({ dispatch }, lineId) {
    try {
      await api.put(`/bank-reconciliation/lines/${lineId}/ignore`);
      await dispatch("getLines");
    } catch (error) {
      console.error("Error ignoring line:", error.message);
      throw error;
    }
  },

  async rematch({ dispatch }) {
    try {
      const result = await api.post("/bank-reconciliation/rematch");
      await dispatch("getLines");
      return result.data;
    } catch (error) {
      console.error("Error re-running auto-match:", error.message);
      throw error;
    }
  },

  async getSummary({ commit }) {
    try {
      const res = await api.get("/bank-reconciliation/summary");
      commit("SET_SUMMARY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching bank reconciliation summary:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
